// extracted by mini-css-extract-plugin
export default {"Box":"add-break-button-module__Box--uQvPF","Box_1":"add-break-button-module__Box_1--X0Pzh","Label":"add-break-button-module__Label--XMsp6"};